/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsMappedResource {
    getFixupPrototypeFunction() { return AppSecopsMappedResource.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsMappedResource>): AppSecopsMappedResource {
        let obj = Object.assign(new AppSecopsMappedResource(), model);
        AppSecopsMappedResource.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsMappedResource>): AppSecopsMappedResource {
        if (!model) return null;
        return AppSecopsMappedResource.newInstance(<AppSecopsMappedResource> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsMappedResource) {
        if (!obj) return;

        models.AppSecopsMappedResource.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsMappedResource): boolean {
        Object.setPrototypeOf(obj, AppSecopsMappedResource.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Type of Resource Mapping
     */
    mapping_type: models.AppSecopsSbomResourceMappingType;

    /**
     * ID of service account
     */
    service_account_id: string;

    /**
     * Category of the mapped resource
     */
    resource_category: string;

    /**
     * Type of the mapped resource
     */
    resource_type: string;

    /**
     * Mapped resource
     */
    resource: string;

    /**
     * Service Resource Inventory ID
     */
    inventory_id: string;

    /**
     * ID of the mapped resource
     */
    resource_id: string;

    /**
     * Name of the mapped resource
     */
    resource_name: string;

}
